// Lightweight sound effects generated with the Web Audio API (no assets needed).
let ctx = null;
let sfxEnabled = true;
let musicEnabled = true;

const MUSIC_URL = (process.env.PUBLIC_URL || "") + "/music/speelslim-jingle.wav";
let musicBuffer = null;
let musicSource = null;
let musicGain = null;
let musicLoading = null;

function ac() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) ctx = new AC();
  }
  if (ctx && ctx.state === "suspended") ctx.resume();
  return ctx;
}

export function setSfxEnabled(v) { sfxEnabled = v; }
export function setMusicEnabled(v) { musicEnabled = v; if (!v) stopMusic(); }

function tone(freq, start, dur, type = "sine", vol = 0.18) {
  const a = ac();
  if (!a) return;
  const o = a.createOscillator();
  const g = a.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, a.currentTime + start);
  g.gain.setValueAtTime(0, a.currentTime + start);
  g.gain.linearRampToValueAtTime(vol, a.currentTime + start + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, a.currentTime + start + dur);
  o.connect(g);
  g.connect(a.destination);
  o.start(a.currentTime + start);
  o.stop(a.currentTime + start + dur + 0.05);
}

export const sound = {
  tap() { if (sfxEnabled) tone(520, 0, 0.08, "triangle", 0.12); },
  correct() {
    if (!sfxEnabled) return;
    tone(660, 0, 0.12, "sine", 0.18);
    tone(880, 0.1, 0.14, "sine", 0.18);
    tone(1180, 0.22, 0.2, "sine", 0.16);
  },
  wrong() {
    if (!sfxEnabled) return;
    tone(200, 0, 0.18, "sawtooth", 0.1);
  },
  reward() {
    if (!sfxEnabled) return;
    [523, 659, 784, 1046].forEach((f, i) => tone(f, i * 0.1, 0.22, "triangle", 0.16));
  },
  pop() { if (sfxEnabled) tone(420, 0, 0.09, "square", 0.1); },
  coin() { if (sfxEnabled) { tone(988, 0, 0.06, "square", 0.12); tone(1319, 0.06, 0.1, "square", 0.12); } },
};

function loadMusic() {
  if (musicBuffer) return Promise.resolve(musicBuffer);
  if (musicLoading) return musicLoading;
  const a = ac();
  if (!a) return Promise.resolve(null);
  musicLoading = fetch(MUSIC_URL)
    .then((r) => r.arrayBuffer())
    .then((buf) => new Promise((res, rej) => a.decodeAudioData(buf, res, rej)))
    .then((decoded) => { musicBuffer = decoded; return decoded; })
    .catch(() => null);
  return musicLoading;
}

export function startMusic() {
  const a = ac();
  if (!a || !musicEnabled || musicSource) return;
  loadMusic().then((buffer) => {
    if (!buffer || !musicEnabled || musicSource) return;
    const src = a.createBufferSource();
    src.buffer = buffer;
    src.loop = true; // sample-accurate seamless loop
    const g = a.createGain();
    g.gain.value = 0.25;
    src.connect(g);
    g.connect(a.destination);
    src.start(0);
    musicSource = src;
    musicGain = g;
  });
}

export function stopMusic() {
  if (musicSource) {
    try { musicSource.stop(); } catch (e) {}
    try { musicSource.disconnect(); } catch (e) {}
    musicSource = null;
  }
  if (musicGain) {
    try { musicGain.disconnect(); } catch (e) {}
    musicGain = null;
  }
}

// Must be called after a user gesture to unlock audio on mobile.
export function unlockAudio() { ac(); }

// Begin the looping background music on the first user gesture (browsers
// block autoplay before an interaction). Respects the music toggle.
let gestureHooked = false;
export function hookMusicAutoStart() {
  if (gestureHooked || typeof window === "undefined") return;
  gestureHooked = true;
  const handler = () => { unlockAudio(); if (musicEnabled) startMusic(); };
  window.addEventListener("pointerdown", handler);
  window.addEventListener("keydown", handler);
}

// Play a single musical note (used by the Muziek games). Always audible
// regardless of the sfx toggle, since it IS the activity.
export function playFreq(freq, dur = 0.5, type = "triangle") {
  const a = ac();
  if (!a) return;
  const o = a.createOscillator();
  const g = a.createGain();
  o.type = type;
  o.frequency.value = freq;
  g.gain.setValueAtTime(0.0001, a.currentTime);
  g.gain.exponentialRampToValueAtTime(0.25, a.currentTime + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, a.currentTime + dur);
  o.connect(g);
  g.connect(a.destination);
  o.start();
  o.stop(a.currentTime + dur + 0.05);
}
